<ion-header *ngIf="showHeader">
  <ion-toolbar>
    <ion-buttons style="padding-left: 10px" slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Ranking</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content (swiperight)="onSwipeRight()" (swipeleft)="onSwipeLeft()">
  <ion-fab slot="fixed" horizontal="end" vertical="bottom">
    <ion-fab-button translucent="true" (click)="showInfo()" size="small">
      <ion-icon name="help-circle-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-segment mode="md" (ionChange)="rankingChanged($event)" [value]="rankingType" color="secondary">
    <ion-segment-button value="boulderer">
      <ion-label>{{"ranking-page.top-boulderer" | translate}}</ion-label>
    </ion-segment-button>
    <ion-segment-button value="creator">
      <ion-label>{{"ranking-page.top-creator" | translate}}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <ion-list *ngIf="boulders else loading">
    <ion-item *ngFor="let rankingEntry of ranking" routerDirection="forward"
              [routerLink]="'/profile/'+rankingEntry.user">
      <medal rank="{{rankingEntry.rank}}"></medal>
      <username [username]="rankingEntry.user"></username>
      <ion-note
        slot="end">{{rankingEntry.score}} {{(rankingEntry.score > 1 ? "ranking-page.points" : "ranking-page.point") | translate}}</ion-note>
    </ion-item>
  </ion-list>
</ion-content>
<ng-template #loading>
  <br><br>
  <h2>{{"ranking-page.load-ranking" | translate}}</h2>
  <p>{{"shared.please-wait" | translate}}</p>
</ng-template>
